
import { BarChart3, MousePointer, Calendar, Clock, Monitor, Globe, Settings, Languages, TrendingUp, DoorOpen, Megaphone } from 'lucide-react';

export const TAB_DEFINITIONS = [
  { id: 'pages', label: 'Pages', icon: BarChart3 },
  { id: 'actions', label: 'Actions', icon: MousePointer },
  { id: 'daily', label: 'Daily', icon: Calendar },
  { id: 'sources', label: 'Sources', icon: TrendingUp },
  { id: 'time', label: 'Time', icon: Clock },
  { id: 'platform', label: 'Platform', icon: Monitor },
  { id: 'browser', label: 'Browser', icon: Globe },
  { id: 'os', label: 'OS', icon: Settings },
  { id: 'language', label: 'Language', icon: Languages },
  { id: 'exitpages', label: 'Exit Pages', icon: DoorOpen },
  { id: 'campaigns', label: 'UTM Campaigns', icon: Megaphone },
];
